import Main from "./Main"
const pages = {
  Main,
};
export default pages;